import m from 'mithril';
import * as L from 'leaflet';


export default {
  oncreate({ state, attrs }) {
    const accessToken = 'pk.eyJ1IjoiYnJhbnNvbmdpdG9tZWgiLCJhIjoiY2pvM2poNHZmMHV5bzN0a3Voa2s0MzNpcCJ9.B_3KsHlW06EOGE5A_UYbsA';
    state.map = L.map('tmpmapid').setView([51.505, -0.09], 13);
    L.tileLayer(`https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=${accessToken}`, {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken,
    }).addTo(state.map);

    state.map.fitWorld().zoomIn();

    state.map.on('resize', (e) => {
      state.map.fitWorld({ reset: true }).zoomIn();
    });
  },
  view() {
    return m("div[id='tmpmapid']", {
      style: {
        height: '314px',
      },
    });
  },
};
